import gql from 'graphql-tag';
import { OrderSummary, ORDER_SUMMARY_FRAGMENT } from '../useOrderSummary';
import { OrderItem, ORDER_ITEM_FRAGMENT } from '../useOrder';

export enum UpdateOrderAction {
  ChangePayment = 'change_payment',
  Charge = 'charge_order',
  UpdatePayment = 'update_payment_summary',
  ChangeAddress = 'change_address'
}

export enum OrderState {
  Charge = 'CHARGE_ORDER',
  Default = 'DEFAULT',
  PayRemainingBalance = 'PAY_REMAINING_BALANCE',
  Failure = 'CHANGE_PAYMENT_PAY_REMAINING_BALANCE'
}

export type UpdateOrderMutation = {
  __typename: 'UpdateOrderPayload';
  data: OrderSummary[];
  included: OrderItem[];
};

export type UpdateOrderMutationVariables = {
  orderId: string;
  input: {
    data: {
      action_type: UpdateOrderAction;
      attributes: {
        country_code: string;
        order_state: OrderState;
        selected_items_ids?: number[];
      };
      id: string;
      type: 'order_summary';
    };
  };
};

export const UPDATE_ORDER_MUTATION = gql`
  mutation UpdateOrder($orderId: String!, $input: UpdateOrderMutationVariables!) {
    updateOrder(orderId: $orderId, input: $input)
    @rest(
      type: "UpdateOrderPayload"
      endpoint: "cart"
      path: "/v3.5/order_summary/{args.orderId}"
      method: "PATCH"
    ) {
      data @type(name: "RestOrderSummary") {
        ...OrderSummaryFragment
      }
      included @type(name: "RestOrderItem") {
        ...OrderItemFragment
      }
    }
  }
  ${ORDER_SUMMARY_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
`;
